import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { RightSidebar } from '~/layout/components/right-sidebar/RightSidebar';
import { RightSidebarTab } from '~/layout/contexts/right-sidebar-layout/RightSidebarLayout';
import { ChatListPanel } from '~/chat/components/chat-list-panel/ChatListPanel';

/**
 * Right-sidebar rail for the AI Coach Chat screen. A single `Chats` tab whose
 * panel renders the conversation list (the new-chat action lives in that panel's
 * header, so the collapsed rail stays a single icon). Renders nothing itself —
 * `<RightSidebar>` registers the tab.
 */
export const ChatListSidebar = () => {
  const { t } = useTranslation('chat');
  const tabs = useMemo<RightSidebarTab[]>(
    () => [
      {
        key: 'chats',
        icon: 'MessageSquare',
        label: t('list.title'),
        panel: <ChatListPanel />,
      },
    ],
    [t],
  );

  return <RightSidebar tabs={tabs} expandedWidth={320} />;
};
